import client from '../httpClient';

const sendmailIdListApi = (offset, limit, obj) => {
  const params = { offset, limit };
  return client.post('/send-mails/id-list', { ...params, ...obj }, { isShowLoading: false });
};

export default sendmailIdListApi;
